<template>
  <v-sheet v-if="items" class="trademarks pb-16" color="transparent">
    <v-sheet class="social" color="secondary">
      <v-container class="d-flex justify-space-between align-center">
        <a href="/">
          <img
            :height="xs ? `80px` : `108px`"
            src="../assets/img/logo-outline.svg"
            :alt="informations.name"
            class="d-block z-index-prefer relative"
          />
        </a>
        <div class="links">
          <div
            v-for="({ text, link, icon, size }, keySocial) in social"
            :key="keySocial"
            class="d-inline-flex"
          >
            <v-btn
              :height="smAndDown ? `30px` : ``"
              :width="smAndDown ? `30px` : ``"
              class="text-caption text-lg-body-1 white--text ml-4"
              :href="link"
              target="_blank"
              color="rgba(255, 255, 255, 0.13)"
              small
              :title="text"
              depressed
              rounded
              fab
            >
              <v-icon :size="smAndDown ? `14` : size">{{ icon }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-sheet>
    <LoadingWidget v-if="loading" />
    <v-container class="pb-0 pt-10" v-else>
      <TitleWidget>Marcas Registradas</TitleWidget>
      <div
        v-if="items.length"
        class="
          d-flex
          justify-sm-space-around justify-center
          flex-wrap
          items-group
          pt-16
          pb-8
        "
      >
        <div v-for="({ title, img, link }, i) in items" :key="i">
          <img v-if="!link" class="item-img" :src="files + img" :alt="title" />
          <a v-else target="_blank" :href="link">
            <img class="item-img d-block" :src="files + img" :alt="title" />
          </a>
        </div>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          height="52px"
          width="166px"
          class="
            text-none
            grey--text
            text--lighten-1
            rounded-0
            elevation-0
            text-h6
            font-weight-bold
          "
          color="primary"
          to="/"
        >
          Voltar
        </v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import { getSocial } from "../utils/getSocial";
const _config = {
  mod: "trademarks",
};
export default {
  components: { LoadingWidget, TitleWidget },
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    social() {
      return getSocial(this.informations);
    },
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then((this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.trademarks {
  .items-group {
    gap: 27px 120px;
    @media (max-width: 600px) {
      gap: 50px;
    }
    @media (max-width: 500px) {
      gap: 30px;
    }
    @media (max-width: 400px) {
      justify-content: space-around !important;
      gap: 10px;
    }
  }
  .item-img {
    filter: grayscale(1);
    height: 100px;
    object-fit: contain;
    aspect-ratio: 1/1;
    transition: all 0.15s;
    &:hover {
      filter: grayscale(0);
    }
  }
}
</style>
